<template>
  <div>
    <v-list-item two-line flat class="px-5" v-if="isAlterVacation">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1">휴일근무일</v-list-item-subtitle>
        <v-list-item-title>
          {{ alterVacationInfo.code }}
          <span class="divider">{{ alterVacationInfo.codeNm }}</span>
          <span class="divider">{{ alterVacationInfo.hour }}시간</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5" v-else-if="isVacation">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >근태종류</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{
          GET_GNT_GUBUN_NM
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">{{
          isAlterVacation || isReward || isCancelReward ? '휴가종류' : '근태명'
        }}</v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{
          GET_GNT_CD_NM
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">{{
          isReward || isCancelReward ? '보상휴가 신청일' : '기간'
        }}</v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ mapPeriod }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5" v-if="mapDateType === 'H'">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">시간</v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ mapTimes }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content
        v-if="mapDateType === 'H' || isReward || isCancelReward"
      >
        <v-list-item-subtitle class="mb-1 app-label"
          >적용시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc"
          >{{ GET_APP_MAP_DATA.requestHour }}시간</v-list-item-title
        >
      </v-list-item-content>
      <v-list-item-content v-else>
        <v-list-item-subtitle class="mb-1 app-label"
          >적용일수</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc"
          ><strong>{{ GET_APP_MAP_DATA.holDay }}</strong
          >일</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <!-- 신청완료시에만 보상휴가 잔여시간 노출 -->
    <v-list-item
      two-line
      flat
      class="px-5"
      v-if="isApplConfirmViewer && (isReward || isCancelReward)"
    >
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >잔여시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{
          rewardRestTime
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">비고</v-list-item-subtitle>
        <v-list-item-content class="app-desc">{{
          GET_MAP_REASON
        }}</v-list-item-content>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line flat class="px-5" v-if="showRestCnt">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >남은연차</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc"
          ><strong>{{ restCnt }}</strong
          >일</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import viewerMixin from '@/mixins/viewerMixin.js';
import { getHolWork, getRestCnt } from '@/api/application';
import dayjs from 'dayjs';
import { mapGetters, mapMutations } from 'vuex';
import applCodeConstants from '@/const/applCodeConstants';
import { getViewerCancelApplButton } from '@/api/ela';

export default {
  mixins: [viewerMixin],
  data: () => ({
    alterVacationInfo: {},
    restCnt: '',
  }),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('ELA', [
      'GET_SEARCH_APPL_SEQ',
      'GET_GNT_CD',
      'GET_REWARD_TOTAL_REST_TIME',
    ]),
    ...mapGetters('CODE', [
      'GET_GNT_GUBUN_OBJ',
      'GET_GNT_GUBUN_NM',
      'GET_GNT_CD_OBJ',
      'GET_GNT_CD_NM',
    ]),
    // 날짜타입(기간, 하루, 시간)
    mapDateType() {
      const reqUseType = this.GET_GNT_CD_OBJ.requestUseType;
      if (
        reqUseType === 'AM' ||
        reqUseType === 'PM' ||
        reqUseType === 'QT1' ||
        reqUseType === 'QT4'
      ) {
        return 'OD'; // one day
      } else if (reqUseType === 'H') {
        return 'H'; // hour
      } else {
        return 'D'; // days
      }
    },
    // 기간
    mapPeriod() {
      const sYmd = dayjs(this.GET_APP_MAP_DATA.sYmd).format('YYYY-MM-DD');
      const eYmd = dayjs(this.GET_APP_MAP_DATA.eYmd).format('YYYY-MM-DD');
      if (this.mapDateType === 'OD' || this.mapDateType === 'H') {
        return `${sYmd}`;
      } else {
        return `${sYmd} ~ ${eYmd}`;
      }
    },
    // 시간
    mapTimes() {
      const sHm = this.GET_APP_MAP_DATA.reqSHm;
      const eHm = this.GET_APP_MAP_DATA.reqEHm;
      if (
        sHm !== null &&
        sHm !== undefined &&
        eHm !== null &&
        eHm !== undefined
      ) {
        return `${sHm.substr(0, 2)}:${sHm.substr(2, 2)}
      ~ ${eHm.substr(0, 2)}:${eHm.substr(2, 2)}`;
      } else {
        return '';
      }
    },

    // 근태 - 대체휴가
    isAlterVacation() {
      return this.isVacation && this.GET_APP_MAP_DATA.gntGubunCd === '11';
    },

    // 잔여 연차 노출 여부
    showRestCnt() {
      return (
        this.GET_GNT_CD_OBJ.gntCdDel !== undefined &&
        this.GET_GNT_CD_OBJ.gntCdDel !== null
      );
    },

    // 보상휴가 잔여시간
    rewardRestTime() {
      return (
        this.GET_REWARD_TOTAL_REST_TIME - this.GET_APP_MAP_DATA.requestHour
      );
    },
  },
  props: {
    appInfoParam: Object,
  },
  watch: {
    isAlterVacation(data) {
      if (data) this.fetchHolWork();
    },
  },
  methods: {
    ...mapMutations('ELA', ['SET_ALTER_VACATION']),

    /*
     * 신청 상세 내용 조회
     * 근태,보상,근태취소,보상취소
     */
    async fetchApplicationMap() {
      this.ON_APP_SPINNER(); // 스피너 ON

      const param = {
        searchApplSeq: this.appInfoParam.applSeq,
        searchApplSabun: this.appInfoParam.applSabun,
      };

      const applCd = this.appInfoParam.applCd;
      if (applCd === applCodeConstants.Vacation) {
        await this.$store.dispatch('ELA/FETCH_VACATION_MAP', param);
      } else if (applCd === applCodeConstants.Reward) {
        await this.$store.dispatch('ELA/FETCH_REWARD_MAP', param);
      } else if (applCd === applCodeConstants.CancelVacation) {
        await this.$store.dispatch('ELA/FETCH_CANCEL_VACATION_MAP', param);
      } else if (applCd === applCodeConstants.CancelReward) {
        await this.$store.dispatch('ELA/FETCH_CANCEL_REWARD_MAP', param);
      }

      this.fetchGntCdList();
    },

    /* 근태명 코드 목록 조회 (gntCd) */
    async fetchGntCdList() {
      try {
        await this.$store.dispatch('CODE/FETCH_GNT_GUBUN_CD_LIST');
        // 보상휴가신청서인지
        const isRewardApplication =
          this.appInfoParam.applCd === applCodeConstants.Reward ||
          this.appInfoParam.applCd === applCodeConstants.CancelReward;
        await this.$store.dispatch('CODE/FETCH_GNT_CD', {
          cmd: isRewardApplication ? 'gntCd' : 'gntCdApp',
          searchGntGubunCd: this.GET_APP_MAP_DATA.gntGubunCd,
        });

        this.SET_GNT_CODE_TMP(this.GET_APP_MAP_DATA.gntCd);
        this.SET_GNT_GUBUN_TMP(this.GET_APP_MAP_DATA.gntGubunCd);

        if (this.showRestCnt) await this.fetchRestCnt();

        this.OFF_APP_SPINNER(); // 스피너 OFF
      } catch (error) {
        console.log(error);
        // this.OFF_APP_SPINNER(); // 스피너 OFF
      }
    },

    /* 대체휴가 조회 */
    async fetchHolWork() {
      try {
        const param = this.GET_APPL_MAP_PARAM;
        param['applStatusCd'] = '';

        const response = await getHolWork(param);
        const element = response.data.data[0];

        let codeNm = element.codeNm;
        element['code'] = dayjs(element.code).format('YYYY-MM-DD');
        element['codeNm'] = codeNm.substring(
          codeNm.indexOf('(') + 1,
          codeNm.indexOf(')'),
        );
        this.alterVacationInfo = element;
        this.SET_ALTER_VACATION(element); // 취소신청시 필요
      } catch (error) {
        console.log(error);
      }
    },

    /* 잔여연차 조회 */
    async fetchRestCnt() {
      try {
        const response = await getRestCnt(this.GET_APPL_MAP_PARAM);
        this.restCnt = response.data.data.restCnt;
      } catch (error) {
        console.log(error);
      }
    },

    /* 취소신청 가능 여부 조회 */
    async fetchViewerCancelApplButton() {
      try {
        const response = await getViewerCancelApplButton({
          searchApplSabun: this.appInfoParam.applSabun,
          applSeq: this.appInfoParam.applSeq,
        });

        const resultData = response.data.data;
        const emitName =
          resultData != null && resultData.btnCancel === '1'
            ? 'showCancelApplBtn'
            : 'hideCancelApplBtn';

        this.$emit(emitName);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchApplicationMap();

    // 뷰어화면에서 기안자=접속유저 AND 신청서상태=처리완료 AND 신청서코드=근태(21),보상휴가(42)
    // 취소버튼 노출 여부
    if (this.isMyBoxViewer) {
      this.fetchViewerCancelApplButton();
    } else if (this.isCancelMenu) {
      this.$emit('showCancelApplBtn');
    }
  },
};
</script>

<style></style>
